import { MapsData, Order, User } from "../../../services";

const loadRouteData = async (order) => {
  const addressList = order.addressList || [];

  if (addressList.length !== 2) {
    return null;
  }

  const loadingAddress = addressList.find((address) => address.type === "Loading");
  const unloadingAddress = addressList.find((address) => address.type === "Unloading");
  const hasLatLng = loadingAddress?.latLng && unloadingAddress?.latLng;
  const routeMethod = hasLatLng ? "getRouteByAddressId" : "getRoute";
  const args = hasLatLng
    ? [loadingAddress.userAddressId, unloadingAddress.userAddressId]
    : [order.cityIdFrom, order.cityIdTo];
  const response = await MapsData[routeMethod](...args);

  if (!response?.data?.jsonData) {
    throw new Error("Missing jsonData");
  }

  const parsedData = JSON.parse(response.data.jsonData);
  return response.data.fromCityId === order.cityIdFrom ? parsedData : parsedData.reverse();
};

const loadCity = async (cityId) => {
  if (cityId == null) return null;

  const response = await Order.getCityById(cityId);
  return response.status === 200 ? response.data : null;
};

const loadCoordinates = async (orderNumber) => {
  if (orderNumber == null) return [];

  const response = await User.getCoordinate(orderNumber);

  if (response.status !== 200 || !Array.isArray(response.data)) {
    return [];
  }

  return response.data.map((coordinate) => ({
    lat: coordinate.latitude,
    lng: coordinate.longitude,
    date: coordinate.createdAt,
    type: coordinate.type,
    gpsEnabledAfter: typeof coordinate.gpsEnabledAfter === "boolean" ? coordinate.gpsEnabledAfter : null,
  }));
};

export const loadOrderMapData = async (order) => {
  const requestNames = ["routeData", "cityFrom", "cityTo", "coordinate"];
  const results = await Promise.allSettled([
    loadRouteData(order),
    loadCity(order.cityIdFrom),
    loadCity(order.cityIdTo),
    loadCoordinates(order.number),
  ]);
  const data = {};
  const errors = [];

  results.forEach((result, index) => {
    const requestName = requestNames[index];

    if (result.status === "fulfilled") {
      data[requestName] = result.value;
    } else {
      errors.push({ requestName, error: result.reason });
    }
  });

  return { data, errors };
};
